import { RoomFeature, RoomType } from 'src/types/cartography.types';

/** Ordre d'affichage des cases à cocher dans le drawer. */
export const ROOM_FEATURES: RoomFeature[] = [
  RoomFeature.BATHTUB,
  RoomFeature.SHOWER,
  RoomFeature.WASHBASIN,
  RoomFeature.DOUBLE_WASHBASIN,
  RoomFeature.TOILET,
  RoomFeature.HAND_BASIN,
  RoomFeature.BIDET,
];

/**
 * Équipements pré-cochés à la création, selon le type choisi. Ce ne sont que des valeurs
 * de départ : l'utilisateur reste libre de les décocher.
 */
export const DEFAULT_FEATURES_BY_TYPE: Partial<Record<RoomType, RoomFeature[]>> = {
  [RoomType.BATHROOM]: [RoomFeature.BATHTUB, RoomFeature.WASHBASIN],
  [RoomType.SHOWER_ROOM]: [RoomFeature.SHOWER, RoomFeature.WASHBASIN],
  [RoomType.POWDER_ROOM]: [RoomFeature.TOILET, RoomFeature.HAND_BASIN],
  [RoomType.TOILET]: [RoomFeature.TOILET],
};

/** Types pour lesquels le bloc « équipements » et l'option « en suite » sont proposés. */
export const WASHROOM_TYPES: RoomType[] = [
  RoomType.BATHROOM,
  RoomType.SHOWER_ROOM,
  RoomType.POWDER_ROOM,
  RoomType.TOILET,
];

export const isWashroomType = (type: RoomType): boolean => WASHROOM_TYPES.includes(type);

/** Types qui portent un couchage : seuls eux peuvent être desservis « en suite ». */
export const SLEEPING_ROOM_TYPES: RoomType[] = [
  RoomType.BEDROOM,
  RoomType.MASTER_BEDROOM,
  RoomType.DORMITORY,
  RoomType.MEZZANINE,
  RoomType.STUDIO_APARTMENT,
];

export const isSleepingRoomType = (type: RoomType): boolean => SLEEPING_ROOM_TYPES.includes(type);

/**
 * Types pour lesquels on propose la saisie de couchages : chambres mais aussi
 * salon, bureau et bibliothèque — on y ajoute parfois un canapé-lit ou un lit d'appoint.
 */
export const BED_CAPABLE_EXTRA_TYPES: RoomType[] = [
  RoomType.LIVING_ROOM,
  RoomType.OFFICE,
  RoomType.LIBRARY,
];

export const canHaveBedsRoomType = (type: RoomType): boolean =>
  isSleepingRoomType(type) || BED_CAPABLE_EXTRA_TYPES.includes(type);
